import React, { useEffect, useState } from 'react';
import { BaseMultiPageModel, ContentTransform, TextElement } from '@bynder-studio/render-core';
import { Form } from '@bynder/design-system';
import MaybeTooltip from 'packages/common/MaybeTooltip';
import generateTestId from '~/helpers/testIdHelpers';
import {
    type AlignmentNumber,
    HORIZONTAL_ALIGNMENTS,
} from 'packages/pages/editor/RightSideMenu/Shots/Text/TextAlignment/utils';
import { AlignmentButton, AlignmentItem, Wrapper } from './Component.styled';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';

type Props = {
    creativeModel: BaseMultiPageModel;
    selectedElement: TextElement;
    contentTransform: ContentTransform;
    disabled?: boolean;
};

const toTestId = (testIdName: string, selected: boolean) =>
    `shots_text_horizontal_alignment_${testIdName}${selected ? '_selected' : ''}`;

const HorizontalAlignment = ({ creativeModel, selectedElement, contentTransform, disabled = false }: Props) => {
    const { id, locked } = selectedElement;
    const { horizontalAlignment } = contentTransform || {};
    const [value, setValue] = useState(horizontalAlignment);

    const handleOnChange = (alignment: AlignmentNumber) => {
        setValue(alignment);
        const param = {
            contentTransform: {
                ...contentTransform,
                horizontalAlignment: alignment,
            },
        };
        creativeModel.updateElement(id, param);
    };

    useEffect(() => {
        setValue(horizontalAlignment);
    }, [horizontalAlignment]);

    return (
        <Form.Group>
            <Wrapper>
                {HORIZONTAL_ALIGNMENTS.map((alignment) => (
                    <AlignmentItem key={alignment.name}>
                        <MaybeTooltip
                            hasTooltip={!locked && !disabled}
                            content={`${alignment.name} (${parseShortcutForTooltip(alignment.shortcut)})`}
                            position="top-left"
                        >
                            <AlignmentButton
                                variant="clean"
                                isPressed={alignment.value === value}
                                isDisabled={locked || disabled}
                                onClick={() => handleOnChange(alignment.value)}
                                {...generateTestId(toTestId(alignment.testIdName, alignment.value === value))}
                            >
                                {alignment.icon({})}
                            </AlignmentButton>
                        </MaybeTooltip>
                    </AlignmentItem>
                ))}
            </Wrapper>
        </Form.Group>
    );
};

export default HorizontalAlignment;
